<template>
    <div ref='scrollWrap' class='article-wrapper'>
        <div class="article-height">
            <!-- <iframe :src='webUrl' style="width: 100%;min-height: 100%;" v-if='isShowIframe'></iframe> -->
            <Blank v-show='noPage' />
            <fixedComponent v-if='showFixed' :signElements='signElement' @goTop='scrollTop' @goBottom='scrollBottom'>
                <template slot='toTop'>
                    <div class="scrollWrap-toTop fixed-box">
                        <!-- <div></div> -->
                    </div>
                </template>
                <template slot='toBottom'>
                    <div class='scrollWrap-toComment fixed-box' :class='{"has-comment" : commentNum > 0}'>
                        <div v-show='commentNum > 0'>
                            {{ commentNum }}
                        </div>
                    </div>
                </template>
            </fixedComponent>
            <component :is="listMap[item.name]" v-for='item in model' :key='item.name+componentKey' :ref='listMap[item.name]' :propsData='item.data' @updateMessage='reciveMsg'>
            </component>
        </div>
    </div>
</template>

<script>
import config from './config'
import { state, mutations } from '@/store'
import Vue from 'vue';
import Blank from '@/common/ui/404'
export default {
    name: '',
    data() {
        return {
            listMap: {
                title: 'thsTitle',
                attribute: 'thsAttribute',
                abstract: 'thsAbstract',
                content: 'thsContent',
                additional: 'thsAdditional',
                tag_info: 'thsTagInfo',
                interact: 'thsInteract',
                comment: 'thsComment',
                disclaimer: 'thsDisclaimer',
            },
            isMax: false, //是否是全屏
            showFixed: false,
            webUrl: '',
            model: [],
            isForbidden: false,
            commentNum: 0,
            signElement: {},
            oldClientWidth: 0,
            noPage: false,
            statFlags: true,
            componentKey: 1,
            onShow: true,
        }
    },
    props: ['seq'],
    inject: ['pageDetail', 'showing'],
    components: { Blank },
    watch: {
        seq: {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.refreshContent(newVal);
                    this.commentNum = 0;
                }
            },
            immediate: true,
        },
        "showing.value": {
            handler(newVal, oldVal) {
                this.onShow = newVal;
                if (newVal) {
                    this.reloadForbiddenTab();
                }
            }
        }
    },
    computed: {
        fontSize() {
            return state.articleFontsize;
        },
    },
    beforeCreate: function () {
    },
    created: function () {
        let componentName = this.pageDetail.componentName;
        this.$router.beforeEach((to, from, next) => {
            if (from.name === componentName && this.isForbidden) {
                this.$client.closeNewTab()
            } else if (to.name === componentName && this.isForbidden) {
                this.$nextTick(_ => {
                    this.openNewClient();
                })
            }
            next()
        })
        this.$nextTick(_ => {
            this.oldClientWidth = this.$refs.scrollWrap.clientWidth
        })
        this.registerEmitterListener();
    },
    mounted: function () {
        window.addEventListener('scroll', this.scrollHandle, true);
    },
    methods: {
        scrollHandle(e) {
            if (e.target.className.includes('left-list')) {//左侧列表

            } else if (e.target.className.includes('right-content')) {//右侧内容滚动
                if (!this.statFlags) {
                    return
                }

                const parentNode = this.$refs.scrollWrap.parentNode // 外层
                const scrollNode = document.querySelector('.article-height')
                const parentNodeScrollTop = parentNode.scrollTop;

                const parentNodeHeight = parseInt(window.getComputedStyle(parentNode).height) // 视口高度
                const scrollNodeHeight = parseInt(window.getComputedStyle(scrollNode).height) // 内容总高度
                console.log('parentNodeScrollTop', parentNodeScrollTop);
                console.log('scrollNodeHeight', scrollNodeHeight);
                console.log('parentNodeHeight', parentNodeHeight);
                if (parentNodeScrollTop > (scrollNodeHeight - parentNodeHeight - 100)) {//100 阈值，可调节
                    this.statFlags = false
                    this.$sendStat(`pc_newschrome_${window.statSeq}.finishread`, { fid: `pc_newschrome_${window.statSeq}.finishread` });
                    this.$sendStat(`pc_newschrome_${window.statSeq}.bottom.statement.show`, { _sid: Math.random() });
                }
            }
        },
        getArt(e) {
            this.$client.closeNewTab()
            console.log('开始请求文章数据', this.filterId(e));
            this.$http.getArt(this.filterId(e)).then(res => {
                console.log('得到文章数据', res)
                this.noPage = false;
                if (res.code == 200) {
                    // 判断是否需要用iframe 打开 包括 同顺号和禁用源
                    if (res.data.copyright == 2) {
                        this.model = [];
                        // if( this)
                        if (!res.data.url) {
                            this.noPage = true;
                        } else {
                            this.isForbidden = true;
                            this.webUrl = res.data.url
                            this.openNewClient();
                        }
                    } else {
                        this.componentKey++
                        this.isForbidden = false;
                        this.model = res.data.componentList;
                        this.$forceUpdate()
                        this.$nextTick(_ => {
                            this.showFixed = true;
                            this.$refs.scrollWrap.parentNode.scrollTop = 0
                            this.signElement = {
                                top: this.$refs.thsTitle[0] ? this.$refs.thsTitle[0].$el : false,
                                bottom: (this.$refs.thsComment && this.$refs.thsComment[0]) ? this.$refs.thsComment[0].$el : false,
                                scrollElement: this.$refs.scrollWrap.parentNode
                            }
                        })

                        this.$dispatch('basic', 'LISTEN_CHILD', {
                            method: 'freshBaseInfo',
                            data: {
                                componentName: this.pageDetail.componentName,
                                collectInfo: res.data.collectInfoObj
                                // title
                            }
                        })
                        this.$emit('changeCollectInfo', res.data.collectInfoObj);
                    }
                }
            })
        },
        reciveMsg(e) {
            if (e.from == 'comment') {
                this.commentNum = e.data.total;
            }
        },
        filterId(obj) {
            return obj.id || obj.seq;
        },
        openNewClient() {
            let tabWrap = this.$refs.scrollWrap
            let tabWrapWidth = tabWrap.clientWidth + 20
            let tabWrapHeight = tabWrap.clientHeight
            let tabWrapLeft = tabWrap.offsetLeft
            let tabWrapTop = tabWrap.offsetTop
            // debugger
            this.$client.openNewTab(this.webUrl, tabWrapLeft, tabWrapTop, tabWrapWidth, tabWrapHeight)
        },
        changeSize() {
            let tabWrap = this.$refs.scrollWrap
            let tabWrapWidth = tabWrap.clientWidth + 20
            let tabWrapHeight = tabWrap.clientHeight
            let tabWrapLeft = tabWrap.offsetLeft
            let tabWrapTop = tabWrap.offsetTop
            this.$client.setTabPos(tabWrapLeft, tabWrapTop, tabWrapWidth, tabWrapHeight)
        },
        initData(e) {
            // debugger
            // 这里可通过页面缓存优化性能 
            this.showFixed = false;
            this.getArt(e)
        },
        changeWindow() {
            if (!this.isMax) {
                this.isMax = true;
                this.$client.viewFullPage();
            } else {
                this.isMax = false;
                this.$client.viewFullPageCancel();
            }
            if (this.isForbidden) {
                this.listenPageSizeChange(this.changeSize)
            }
        },
        listenPageSizeChange(cb) {
            let tabWrap = this.$refs.scrollWrap
            let tabWrapWidth = tabWrap.clientWidth
            if (this.oldClientWidth && this.oldClientWidth != tabWrapWidth) {
                this.oldClientWidth = tabWrapWidth
                cb()
                return;
            }
            if (this.oldClientWidth && this.oldClientWidth === tabWrapWidth) {
                cb();
                return;
            }
            let interval = setInterval(() => {
                if (tabWrapWidth !== tabWrap.clientWidth) {
                    this.oldClientWidth = tabWrap.clientWidth
                    clearInterval(interval)
                    cb()
                }
            }, 1)
        },
        // 滚到顶部
        scrollTop() {
            // this.$sendStat(this.$pageStat(this.seq, 'elevator')('elevatortop'))
            this.$sendStat(`pc_newschrome_${window.statSeq}.commentselevator.zhengwen`);
        },
        // 滚到底部
        scrollBottom() {
            this.$sendStat(`pc_newschrome_${window.statSeq}.commentselevator.pinglun`);

            console.log('到底了~~~~~~~~~~~~')
            // this.$sendStat(this.$pageStat(this.seq, 'elevator')('elevatorcomment'))

            // this.$sendPoint('xwover');
            // this.$sendPoint('pageover');
        },
        // 重新加载禁用源tab
        reloadForbiddenTab() {
            if (this.isForbidden) {
                this.$client.closeNewTab()
                this.openNewClient();
            }
        },
        registerEmitterListener() {
            this.$client.registerEventNotify((res) => {
                let arr = JSON.parse(res)[0].split("=");
                let key = arr[0];
                if (key == "windowSize") {
                    arr[1] == "normal" ? (this.isMax = true) : (this.isMax = false);
                    if (this.onShow) {
                        this.changeWindow();
                    }
                }
            })
        }
    }
}
</script>

<style lang="less">
.article-wrapper {
    position: relative;
    height: 100%;
    .fixed-box {
        position: relative;
        border-radius: 50%;
        height: 50px;
        width: 50px;
        background-color: rgba(37, 37, 37, 0.49);
        background-size: 22px 22px;
        background-repeat: no-repeat;
        background-position: center;
        // filter: blur(2px);
    }
    .scrollWrap-toTop {
        background-image: url('//s.thsi.cn/webprivate/pcnews/2.0/img/topFixed.png');
    }
    .scrollWrap-toComment {
        background-image: url('//s.thsi.cn/webprivate/pcnews/2.0/img/commentFixed.png');
        div {
            position: absolute;
            top: 6px;
            right: 8px;
            width: 16px;
            // text-align: center;
            color: #eee;
            font-size: 10px;
        }
        &.has-comment {
            background-image: url('//s.thsi.cn/webprivate/pcnews/2.0/img/commentFixed2.png');
        }
    }
}
.night {
    .article-wrapper {
        .fixed-box {
            background-color: rgba(37, 37, 37, 0.49);
        }
        .scrollWrap-toComment {
            background-image: url('//s.thsi.cn/webprivate/pcnews/2.0/img/commentFixed.png');
            &.has-comment {
                background-image: url('//s.thsi.cn/webprivate/pcnews/2.0/img/commentFixed2b.png');
            }
        }
    }
}
</style>
